import { Socket, io } from "socket.io-client";

class WebSocketService {
  private socket: Socket | null = null;

  connect(serverAddress: string): void {
    this.socket = io(serverAddress);

    this.socket.on("connect", () => {
      console.log("Connected to WebSocket server");
    });

    this.socket.on("disconnect", () => {
      console.log("Disconnected from WebSocket server");
    });
  }

  joinNotificationRoom(userId: string): void {
    if (this.socket) {
      this.socket.emit("joinNotificationRoom", userId);
    }
  }

  //   new notification listener
  onNewNotification(callback: (notification: any) => void): void {
    if (this.socket) {
      this.socket.on("newNotification", (notification) => {
        callback(notification);
      });
    }
  }

  // join chat room
  joinChatRoom(chatId: string): void {
    if (this.socket) {
      this.socket.emit("joinChatRoom", chatId);
    }
  }

  // join chat notification room
  joinChatNotificationRoom(userId: string): void {
    if (this.socket) {
      this.socket.emit("joinChatNotificationRoom", userId);
    }
  }


  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
}

const webSocketService = new WebSocketService();
export default webSocketService;
